import React from 'react';
import { AdminPageLayout } from '@/components/admin/AdminPageLayout';
import { AdminCard } from '@/components/admin/AdminCard';
import FeatureRequests from '@/components/help/FeatureRequests';
import { Lightbulb } from 'lucide-react';
import { motion } from 'framer-motion';

// Animation variants
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};

const FeatureRequestsPage: React.FC = () => {
  return (
    <motion.div 
      variants={containerVariants} 
      initial="hidden" 
      animate="visible"
    >
      <AdminPageLayout 
        title="Feature Requests" 
        description="Submit new feature ideas and vote on existing requests from the community"
        icon={Lightbulb}
        maxWidth="7xl"
      >
        <motion.div variants={itemVariants}>
          <AdminCard>
            <FeatureRequests />
          </AdminCard>
        </motion.div>
      </AdminPageLayout>
    </motion.div>
  );
};

export default FeatureRequestsPage;